// 2026-09-24 - FormuLearning - Step 4 결과 저장 진행·미저장 편집 상태 (이슈 #76 G5, M901-32)
// 파일 위치: frontend/src/stores/step4PendingStore.ts
// 목적: 회의(260901) *"실험결과 입력 후 save 끝나기 전에는 next optimization 이 되지 않게 잠그자"*.
//       Step 4 의 결과 저장(용출·Y·조성·제외)은 컴포넌트마다 지역 상태로만 진행을 쥐고 있어
//       Next Optimization 이 볼 수 없었다. 저장 진행 수와 미저장 편집 표식을 여기 모은다.
//
// `busyStore`(#82)와 `saveBufferStore`(Step 2·3 지연 저장)를 쓰지 않는 이유 — busyStore 는 동시 1건·
// 소유 스텝 잠금 면제라 Step 4 자기 버튼을 잠그지 못하고, saveBufferStore 는 Autosave OFF 의 스텝 단위
// 지연 저장 버퍼라 배치 단위 즉시 저장과 성격이 다르다(검토 §4.5).

import { create } from 'zustand'

interface Step4PendingState {
  /** 진행 중 저장 왕복 수. */
  saving: number
  /** 미저장 편집 표식 — 키 예: `diss:{batchId}` · `y:{batchId}`. */
  dirty: Record<string, true>
  begin: () => void
  end: () => void
  setDirty: (key: string, on: boolean) => void
  reset: () => void
}

export const useStep4Pending = create<Step4PendingState>((set) => ({
  saving: 0,
  dirty: {},
  begin: () => set((s) => ({ saving: s.saving + 1 })),
  end: () => set((s) => ({ saving: Math.max(0, s.saving - 1) })),
  setDirty: (key, on) =>
    set((s) => {
      if (Boolean(s.dirty[key]) === on) return s        // 변화 없으면 리렌더 회피
      const next = { ...s.dirty }
      if (on) next[key] = true
      else delete next[key]
      return { dirty: next }
    }),
  reset: () => set({ saving: 0, dirty: {} }),
}))

/** 저장 왕복을 진행 수에 올린다 — 실패해도 반드시 내린다. */
export async function trackSave<T>(fn: () => Promise<T>): Promise<T> {
  useStep4Pending.getState().begin()
  try {
    return await fn()
  } finally {
    useStep4Pending.getState().end()
  }
}

/** Next Optimization 잠금 사유. 잠그지 않으면 null. */
export function pendingReason(s: Pick<Step4PendingState, 'saving' | 'dirty'>): string | null {
  if (s.saving > 0) return '실험 결과를 저장하는 중입니다 — 저장이 끝나면 실행할 수 있습니다.'
  if (Object.keys(s.dirty).length > 0) return '저장하지 않은 실험 결과가 있습니다 — 먼저 Save 하십시오.'
  return null
}
